module.exports = __webpack_public_path__ + "img/e-bike-2-line.f6c53cd0.svg";